import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type DisclaimerColors = 'orange' | 'gray' | 'light-gray' | 'red' | 'green';
export type DisclaimerIcons = '' | 'ic-alert-triangle-20' | 'ic-info-circle-20' | 'ic-cancel-circle-20' | 'ic-edit-20' | 'ic-checkmark-circle-20';

@Component({
  selector: 'app-disclaimer',
  standalone: true,
  imports: [],
  templateUrl: 'disclaimer.component.html',
  styleUrl: 'disclaimer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisclaimerComponent {
  @Input() icon: DisclaimerIcons = 'ic-alert-triangle-20';
  @Input() color: DisclaimerColors = 'orange';
  @Input() content: string | null = null;
}
